import type {
  IconMap,
  SocialLink,
  Site,
  Language,
  NavLink,
  GitHubContributionConfig,
} from '@/types'

// Default language - this will be used for URLs without language prefix
export const DEFAULT_LANGUAGE = 'en'

// Supported languages configuration
export const LANGUAGES: Record<string, Language> = {
  es: {
    code: 'es',
    name: 'Español',
    locale: 'es-ES',
  },
  en: {
    code: 'en',
    name: 'English',
    locale: 'en-US',
  },
}

export const SITE: Site = {
  title: 'Juan Toca',
  description:
    'A blog on engineering, projects, life, the universe and everything',
  href: 'https://juantoca.net',
  author: 'juantoca',
  locale: 'es-ES',
  featuredPostCount: 2,
  postsPerPage: 6,
}

export const NAV_LINKS: NavLink[] = [
  {
    href: '/blog',
    label: 'Blog',
    translations: {
      en: 'Blog',
      es: 'Blog',
    },
  },
  {
    href: '/about',
    label: 'About',
    translations: {
      en: 'About',
      es: 'Sobre mi',
    },
  },
]

// GitHub username used to fetch open source contributions
export const GITHUB_USERNAME = 'juantoca'

// Curate the Open Source Contributions section:
// - excludeRepos: hide PRs from these repos (use "owner/repo")
// - excludePrs: hide specific PRs (use their full GitHub URL)
// - extra: add PRs by hand (just their full GitHub URL); title, repo and date
//   are fetched automatically, so it also works for PRs from an old account
export const GITHUB_CONTRIBUTIONS: GitHubContributionConfig = {
  username: GITHUB_USERNAME,
  limit: 8,
  excludeRepos: [
    'Syknapse/Contribute-To-This-Project',
    'Sialitech/image-segmentation-keras',
  ],
  excludePrs: [],
  extra: [
    "https://github.com/readthedocs/readthedocs.org/pull/9794"
  ],
}

export const SOCIAL_LINKS: SocialLink[] = [
  {
    href: 'https://github.com/juantoca',
    label: 'GitHub',
  },
  {
    href: 'mailto:juantocamateo17@gmail.com',
    label: 'Email',
  },
  {
    href: 'https://www.linkedin.com/in/juantocamateo/',
    label: 'LinkedIn',
  },
  {
    href: '/rss.xml',
    label: 'RSS',
  },
]

export const ICON_MAP: IconMap = {
  Website: 'lucide:globe',
  GitHub: 'lucide:github',
  LinkedIn: 'lucide:linkedin',
  Twitter: 'lucide:twitter',
  Email: 'lucide:mail',
  RSS: 'lucide:rss',
}
